export default __webpack_public_path__ + "static/media/home-login.0d9dc26c.jpg";